import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import civilFacultyData from "./facultyData/civilFacultyData";

const facultyOrder = [
  "f-ashik-bellary",
  "f-siddalingayya-g-hiremath",
  "f-laxmi-g-hattiholi",
  "f-vijaylaxmi-b-vyakaranahal",
  "f-harshvardhan-v-s",
  "f-seema-basarikatti",
  "f-rakesh-patil",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const facultyData = {
  ...civilFacultyData,
  members: getOrderedFacultyMembers(civilFacultyData.members),
};

export const programme = {
  id: "civil",
  name: "Civil Engineering",
  short: "Civil",
  programmeType: "ug",
  programmeLabel: "Undergraduate Programme",
  duration: "4 Years",
  intake: 30,
  studentsEnrolled: null,
  // facultyStrength: null,
  phdFaculty: null,
  established: 2010,

  description:
    "The Department of Civil Engineering was started in the academic year 2010-2011. The department is headed by Mr. Harsha A. Jadhav and is supported by experienced faculty members. The department is well equipped with modern instruments to carry out laboratory experiments and practical learning activities. The department also has a students’ association, ACES, which conducts technical talks, site interactions with alumni, quizzes and other activities to encourage students and showcase their talents.",

  image:
    "/HomePage/dept/civil.jpeg",

  hodId: "f-harsha-a-jadhav",
  facultyDeptId: "civil",
  facultyData,

  labs: [
    "Basic Material Testing Laboratory",
    "Concrete and Highway Materials Laboratory",
    "Geotechnical Engineering Laboratory",
    "Environmental Engineering Laboratory",
    "Surveying Laboratory",
    "Fluid Mechanics and Hydraulics Laboratory",
    "Computer Aided Design Laboratory",
   
  ],

  research:
    "Geotechnical Engineering · Environmental Engineering · Transportation Engineering · Surveying · Construction Management",

  accreditation: [
    "Affiliated to Visvesvaraya Technological University (VTU), Belagavi",
    "Approved by All India Council for Technical Education (AICTE), New Delhi",
    "Recognized with NAAC 'A' Accreditation"
  ],

  achievements: [
    {
      title: "Achievement Documents",
      items: [
        { label: "AICTE Certificate - Harshavardhan V S", href: "/Achievements/Civil/CERTIFICATE-AICTE-QIP-2.pdf" },
        { label: "AICTE Certificate - Rakesh Patil", href: "/Achievements/Civil/certificate-RJP.pdf" },
        { label: "AICTE Certificate - Ashik Bellary", href: "/Achievements/Civil/IMG_20250415_124746.pdf" },
        { label: "Certificate of Appreciation - Vijaylaxmi B V", href: "/Achievements/Civil/S.TAppreciation-Letter5-Prof.-Vijaylaxmi-B-V_-KLS-VDIT-Haliyal-_-Karnataka-_-24-25.pdf" },
  
      ],
    },
  ],

  dashboard: [
    ["Faculty Members", "09"],
    ["Faculty with Ph.D.", "02"],
    ["Faculty pursuing Ph.D", "04"],
    ["Laboratories", "08"],
    
  ],
  academicVision:
    "To excel in imparting civil engineering knowledge of global standards in meeting societal and environmental challenges with professional ethics",

  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The Civil Engineering department has nine qualified faculty members and well-equipped laboratories that support effective learning. Students benefit from VTU-based academics, software training, technical activities, industrial visits, internships, seminars, workshops, and project-based learning, which enhance their practical and professional skills.",
      
    },
    {
      title: "Mission",
      text: [
        "To develop entrepreneurial and skill and team work among students.",
        "To inculcate basics of civil engineering knowledge to meet the professional challenges through research and innovation in collaboration with industries.",
        "To cultivate qualities of professional ethics and commitment towards welfare of the 	society and environment.",
      
      ],
    },
    {
      title: "Beyond Syllabus",
      text:
        "The Civil Engineering department enriches student learning through ACES student association activities, technical talks, site visits, building model-making competitions, industry internships, surveying and construction practice exposure, research and innovation projects, professional body activities, workshops, industry interactions, entrepreneurship initiatives, and multidisciplinary project development, fostering practical knowledge, leadership, problem-solving abilities, and industry readiness.",
    },
  ],

  curriculumSupport: [
    "VTU-prescribed syllabi and structured laboratory courses.",
    "Industrial visits and site interaction programmes.",
    "Technical talks, seminars and workshops.",
    "Project-based learning and internships.",
    "Add-on courses and software training.",
    "AutoCAD, STAAD Pro, Primavera, MS Project and QGIS support.",
    "ACES student association activities.",
    "Industry interaction programmes and consultancy exposure.",
    "E- Survey and Onsite alumni interaction"
  ],

  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],

  pso: [
    "Graduates will be able to plan, analyse and design in order to execute and maintain civil engineering structures using alternative materials and innovative construction practices for sustainable infrastructural development of the nation.",
    "Graduates will be able to pursue career opportunities for personal and professional growth by demonstrating leadership skill, professional integrity and solve issues related to civil engineering and allied fields.",
  ],

  peo: [
    "To design and utilize new materials, processes, and projects through research and development for the welfare of society.",
    "To communicate feasible technical solutions for civil engineering problems faced by public through presentations and demonstrations.",
    "To enhance the personal knowledge, leadership quality and entrepreneurial skill to succeed in civil engineering profession.",
  ],

  infrastructure: [
    ["Classrooms", "Smart Classroom"],
    ["Laboratories", "8"],
    ["Seminar Halls", "No"],
    ["Project Rooms", "No"],
    ["Department Library", "Yes"],
    ["Software Tools", "AutoCAD, STAAD Pro, QGIS"],
    [
      "Equipment Highlights",
      "Universal Testing Machine, Tile Abrasion Test Apparatus, Self Compacting Concrete Test Instruments, RCPT, Total Station, Brick Making Machine, GPS, Universal Force Table, Bell Crank Apparatus and Simply Supported Beam Apparatus.",
    ],
  ],
  infrastructureImages: [
    {
      src: "/HomePage/dept/civil.jpeg",
      title: "Civil Engineering Infrastructure",
      alt: "Civil Engineering department infrastructure",
    },
  ],

  studentActivities: {
    clubs: [
      {
        name: "ACES - Association of Civil Engineering Students",
        category: "Student Club",
        description:
          "ACES supports technical talks, project activity, student engagement, and peer learning for Civil Engineering students.",
        image: "/student-club/CIVIL/ACES_l.png",
        reports: [
          { title: "ACES Report 1", href: "/student-club/CIVIL/ACES/Activities_2025–26/Farewell-18th-May-2026.pdf" },
          // { title: "ACES Report 2", href: "#" },
        ],
      },
    ],
    
  },
  newsEvents: {
    reports: [
      { label: "Alumni Talk 25th-Aug-2025", href: "/EVENTS/CIVIL/ACTIVITIES_2025/Alumni-Talk_25th-Aug-2025.pdf" },
      { label: "Field Visit 29th-Aug-2025", href: "/EVENTS/CIVIL/ACTIVITIES_2025/Field-Visit_29th-Aug-2025.pdf" },
    ],
  },
  featuredVideo: {
    title: "Department Video",
    sub: "A message from the Head of Department",
    embedUrl: "https://www.youtube.com/embed/d6_M8boAluE",
    iframeTitle: "Department Video",
  },

  consultancy: [
    "Non-Destructive Testing (NDT)",
    "Bricks and Concrete Blocks Testing",
    "HYSD Steel Testing",
    "Soil Testing",
    "Water Quality Analysis",
  ],

  facultyTable: [
    ["Mr. Harsha A. Jadhav", "To be updated", "To be updated"],
  ],

  teachingStaff: [
    ["Mr. Harsha A. Jadhav", "HoD and Assistant Professor"],
  ],

  nonTeachingStaff: [
    ["Mr. Praveen K", "Asst. Instructor"],
    ["Mr. Karibasappa D", "Asst. Instructor"],
    ["Mr. Shamsundar Joshi", "Mechanic"],
    ["Mr. Suresh H", "Attender"],
    ["Mr. Ashpak D", "Peon"],
    ["Mr. Praveen K", "Asst. Instructor"],
  ],

  downloads: [
    "Calendar of Events",
    "Time Table",
    "COs, PEOs and PSOs",
    "Question Paper Solutions",
    "Mentor-Mentee List",
    "IA Test Syllabus",
    "Staff Profile",
    "Industry Connect",
    "VTU Syllabus Link",
    "Add-On Courses",
  ],
};

const Civil = () => <ProgrammeDetail programme={programme} />;

export default Civil;
